module.exports = __webpack_public_path__ + "static/media/OBE_interior1-min.2c46070b.jpg";